<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 24 22"
  >
    <g fill-rule="evenodd">
      <path d="M20.769 13C19.856 17.002 16.275 20 12 20 7.945 20 4.511 17.304 3.389 13.611L6 11 0 11 0 17 1.827 15.173C3.475 19.173 7.412 22 12 22 17.382 22 21.865 18.112 22.809 13L20.769 13zM22.173 6.827C20.526 2.826 16.589 0 12 0 6.618 0 2.135 3.888 1.191 9L3.231 9C4.144 4.998 7.725 2 12 2 16.055 2 19.489 4.696 20.611 8.39L18 11 24 11 24 5 22.173 6.827z" />
      <path
        v-if="!loading"
        d="M8.25 16C8.25 13.699 9.699 12.25 12 12.25 14.301 12.25 15.75 13.699 15.75 16L8.25 16zM12 6C13.381 6 14.5 7.119 14.5 8.5 14.5 9.881 13.381 11 12 11 10.619 11 9.5 9.881 9.5 8.5 9.5 7.119 10.619 6 12 6"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'UpdateProfileIcon',
    props: {
      loading: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>

  path {
    fill: inherit;

    transform-origin: center center;
  }

  div:hover > svg {
    path:first-child {
      transition: transform 600ms ease-in-out;
      transform: rotate(360deg);
    }
  }
</style>
